export default [
  {
    icon: 'mdi-pencil',
    title: 'Ubah Peserta',
    event: 'onUbahPeserta',
    akses: 'psp-pelatihan-imbas.save',
  },
  {
    icon: 'mdi-close',
    title: 'Hapus Peserta',
    event: 'onHapusPeserta',
    akses: 'psp-pelatihan-imbas.reset',
  },
];
